document.addEventListener('click', (e) => {
  const btn = e.target.closest('.share-buttons__copy');
  if (!btn) return;
  const url = btn.dataset.copyUrl;
  if (!url) return;
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(url).then(() => showFeedback(btn));
  } else {
    const ta = document.createElement('textarea');
    ta.value = url;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand('copy');
      showFeedback(btn);
    } catch (_) { /* noop */ }
    document.body.removeChild(ta);
  }
});

function showFeedback(btn) {
  const feedback = btn.querySelector('.share-buttons__copy-feedback');
  if (!feedback) return;
  feedback.hidden = false;
  setTimeout(() => { feedback.hidden = true; }, 1500);
}
